import $ from 'jquery';
import enableCaptchaFunctionality from 'Common/captcha';
import enableValidationFunctionality from './validation';
/**
 * Enables the forms functionality.
 */
const enableFormsFunctionality = () => {
    enableCaptchaFunctionality();
    enableValidationFunctionality();
    $('form').each(function () {
        const form = $(this);
        // color the select element text based on whether it has a selected non-empty option
        $('select', form).each(function () {
            const select = $(this);
            _toggleEmptySelectClass(select);
            select.on('change', () => {
                _toggleEmptySelectClass(select);
            });
        });
        // swap between text and date input types so a placeholder can be used
        $('input.date', form).each(function () {
            const input = $(this);
            input.on('blur', () => {
                if (!input.val()) {
                    input[0].type = 'text';
                }
            });
            input.on('focus', () => {
                input[0].type = 'date';
            });
        });
        // swap between text and time input types so a placeholder can be used
        $('input.time', form).each(function () {
            const input = $(this);
            input.on('blur', () => {
                if (!input.val()) {
                    input[0].type = 'text';
                }
            });
            input.on('focus', () => {
                input[0].type = 'time';
            });
        });
    });
    /**
     * Toggles whether a `select` element has the `empty-option` CSS class.
     * @param $select - The `select` element.
     */
    function _toggleEmptySelectClass($select) {
        if (!$select.val()) {
            $select.addClass('empty-option');
        }
        else {
            $select.removeClass('empty-option');
        }
    }
};
export default enableFormsFunctionality;
